import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Modal, Button, ButtonToolbar} from 'react-bootstrap'
import OpeningTicketPurposePicker from '../../reference/components/OpeningTicketPurposePicker'
import {sendAssociateOpeningTicketPurposeWithInstructionAction, sendDissociateOpeningTicketPurposeFromInstructionAction, loadOpeningTicketInstructionStream} from '../actions'
import i18n from '../i18n'

function openingTicketPurposeAggregator(reference) {
    return (result, openingTicketPurpose) => {
        const resultOpeningTicketPurpose = reference.openingTicketPurposes.find((otp) => otp.uid == openingTicketPurpose.uid)

        if (resultOpeningTicketPurpose) {
            result.push(resultOpeningTicketPurpose)
        } else {
            console && console.warn('openingTicketPurpose "' + openingTicketPurpose.uid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

class AssociateDissociateOpeningTicketPurposeFromInstructionModal extends Component {
    static propTypes = {
        openingTicketInstruction: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            openingTicketPurposes: []
        }
    }

    componentWillMount() {
        const {dispatch, openingTicketInstruction, reference} = this.props

        const openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), [])
        this.setState({openingTicketPurposes})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openingTicketInstruction != this.props.openingTicketInstruction) {
            const {dispatch, openingTicketInstruction, reference} = nextProps

            const openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), [])
            this.setState({openingTicketPurposes})
        }
    }

    _sendAction(action, openingTicketPurpose) {
        const {dispatch, openingTicketInstruction} = this.props

        switch(action) {
            case 'Add':
                return dispatch(sendAssociateOpeningTicketPurposeWithInstructionAction(openingTicketInstruction.uid, openingTicketPurpose.uid)).then(() => {
                    return dispatch(loadOpeningTicketInstructionStream())
                })
            case 'Remove':
                return dispatch(sendDissociateOpeningTicketPurposeFromInstructionAction(openingTicketInstruction.uid, openingTicketPurpose.uid)).then(() => {
                    return dispatch(loadOpeningTicketInstructionStream())
                })
        }
    }

    render() {
        const {dispatch, company, reference, openingTicketInstruction, onHide, ...others} = this.props
        const {openingTicketPurposes} = this.state

        return (
            <Modal
                bsSize='large'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.openingTicketPurposes}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OpeningTicketPurposePicker multi split
                        company={company}
                        value={openingTicketPurposes}
                        onSubmit={(a, otp) => this._sendAction(a, otp)} />
                    <ButtonToolbar>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

AssociateDissociateOpeningTicketPurposeFromInstructionModal = connect((state) => ({
    company: state.company.company,
    reference: state.reference.openingTicketPurposeRef
}))(AssociateDissociateOpeningTicketPurposeFromInstructionModal)

export default AssociateDissociateOpeningTicketPurposeFromInstructionModal


// WEBPACK FOOTER //
// ./lib/message/components/AssociateDissociateOpeningTicketPurposeFromInstructionModal.js